import { createSharedModule } from '@izimi/modules';

import { sharedApi } from '../di';

export const sharedModule = createSharedModule({ sharedApi });
